import { render, staticRenderFns } from "./AbscessScarringAndPericarditis.vue?vue&type=template&id=38a77f01&scoped=true&v-if=currentReportDetails&"
import script from "./AbscessScarringAndPericarditis.vue?vue&type=script&lang=ts&"
export * from "./AbscessScarringAndPericarditis.vue?vue&type=script&lang=ts&"
import style0 from "./AbscessScarringAndPericarditis.vue?vue&type=style&index=0&id=38a77f01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a77f01",
  null
  
)

export default component.exports